import { inject, Injectable } from '@angular/core';

import { AppKind, ORG_GUID } from '@core/tellent-types';
import { injectTellentAppUrlOpener } from '@core/tellent-util';

@Injectable()
export class TellentGrowRedirectService {
  private readonly orgGuid = inject(ORG_GUID);
  private readonly tellentAppUrlOpener = injectTellentAppUrlOpener();

  public createNewSkillRedirect(): void {
    this.tellentAppUrlOpener(
      AppKind.Javelo,
      {
        id: 'skills:create',
      },
      this.orgGuid!,
      '_blank',
    );
  }

  public manageSkillMappingsRedirect(skillMappingId?: number): void {
    this.tellentAppUrlOpener(
      AppKind.Javelo,
      {
        id: 'skill-mappings',
        params: { skillMappingId: skillMappingId?.toString() },
      },
      this.orgGuid!,
      '_blank',
    );
  }
}
